// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"example_wrapper_3kp_m","title":"example_title_dhJ98","showCode":"example_showCode_2FNdf","codeIcon":"example_codeIcon_HV2O5","expDemoWrapper":"example_expDemoWrapper_2jOal"};


//////////////////
// WEBPACK FOOTER
// ./src/docs/components/example.css
// module id = 79
// module chunks = 0